import { buildTimingSummary, type TimingSummaryItem } from '../utils/timingSummary';
import { RoomStudent } from '../types/Rooms';

interface UseMonitorTimingSummaryProps {
  students: RoomStudent[];
}

interface UseMonitorTimingSummaryResult {
  startSummaryText: string | null;
  endSummaryText: string | null;
}

export function useMonitorTimingSummary({ students }: UseMonitorTimingSummaryProps): UseMonitorTimingSummaryResult {
  const timingItems: TimingSummaryItem[] = students.map((student: RoomStudent) => ({
    examStartTime: student.examStartTime,
    estimatedExamEndTime: student.estimatedExamEndTime,
  }));

  const { startSummaryText, endSummaryText } = buildTimingSummary(timingItems);

  return { startSummaryText, endSummaryText };
}
